import {Stack, Typography} from "@mui/material";
import {appStyles} from "../../../../AppStyles.ts";

function UXResourceContentResourcesPanel() {
    return (
        <Stack sx={appStyles.defaultPanelContainer} direction="column" padding={1} width="100%">
            <Stack direction="row" padding={1} justifyContent="center">
                <Typography sx={appStyles.panelSectionTitle}>Content Resources</Typography>
            </Stack>

            <Stack direction="row" spacing={1} padding={1} alignItems="center" justifyContent="center">
                <Typography sx={{
                    color: "rgba(242, 245, 250, 0.4)",
                    fontSize: "0.80rem",
                    textAlign: "center",
                    padding: "24px",
                }}>
                    This feature is not yet available
                </Typography>
            </Stack>
        </Stack>
    );
}

export default UXResourceContentResourcesPanel;
